module.exports = __webpack_public_path__ + "img/scene3.1e308dfc.png";